import React, { Component } from "react";
import { translate } from "react-i18next";
import swal from 'sweetalert';

import BreadcrumbTitle from "../../../components/BreadcrumbTitle";
import ButtonForm from '../../../components/ButtonForm';

import LabSections from "./LabSections";

import { sampleResultsSave, validatorGetResults, validator, samplesLabInfo, validatorDelete } from "../../../libs/services";
import Laboratory from "../toolbar/Laboratory";
import SelectSectionLab from "../SelectSectionLab";
import SampleInfoCells from "./SampleInfoCells";
import Button from "../../../components/Button";

class LaboratoryForm extends Component{
    constructor(props){
        super(props);

        this.getLabSections = this.getLabSections.bind(this);
        this.changeResultValue = this.changeResultValue.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onValidate = this.onValidate.bind(this);
        this.onRemoveValidation = this.onRemoveValidation.bind(this);
        this.getSampleInfo = this.getSampleInfo.bind(this);
        this.openModalSections = this.openModalSections.bind(this);

        this.state = {
            sections:[],
            saved:false,
            samples_id:"",
            sample_info:{
                offerinf_cell_id:null,
            }
        }
    }   

    async componentDidMount(){
        var id = this.props.match.params.id;
        await this.getSampleInfo(id);
        await this.getLabSections();
    }

    async getSampleInfo(id){
        var response = await samplesLabInfo(id, this.props.waiting);
        if(response){
            response.personPhen = '';
            response.phenotype = '';
            response.person_phenotypes.forEach((f)=>{
                response.personPhen += f.phenotype1+f.result+',  '
            });
            response.phenotypes.forEach((f)=>{
                response.phenotype += f.phenotype1+f.result+',  '
            });
            response.personAnti = '';
            response.antibody = '';
            response.person_phenotypes.forEach((f)=>{
                response.personAnti += f.phenotype1+f.result+',  '
            });
            response.phenotypes.forEach((f)=>{
                response.antibody += f.phenotype1+f.result+',  '
            });
            
            this.setState({sample_info:response});
        }
    }
    
    async getLabSections(){
        var id = this.props.match.params.id;
        var hf_id = sessionStorage.getItem('health_facilities_id');
        
        this.setState({samples_id:id});
        
        var response = await validatorGetResults(hf_id, id, this.props.waiting);
        if(response){
            response.forEach((res)=>{
                res.TestList.forEach((test)=>{
                    test.value = test.Result !== null ? test.Result.value : '';
                    test.numeric_value = test.Result !== null ? test.Result.numeric_value : '';

                    var index = test.AcceptedValues.findIndex(item => item.value === test.value);
         
                    if(index !== -1){
                        var highlight = test.AcceptedValues[index].Highlight;
                        
                        test.accepted = !highlight;
                    }else{
                        test.accepted = true
                    }

                    test.AcceptedValues.forEach((val)=>{
                        val.value = val.Value;
                        val.text = val.Value;
                    });
                    
                    test.validated = test.Result !== null ? test.Result.validated : false;
                });
            });
            this.setState({sections:response});
        }
    }

    changeResultValue(e, obj){
        var sections = this.state.sections;
        var value = e.target.value;
        var i = obj.section;
        var j = obj.test;

        if(obj.type === 'combo'){
            sections[i].TestList[j].value = e.target.value;

            var index = sections[i].TestList[j].AcceptedValues.findIndex(item => item.value === value);
         
            if(index !== -1){
                var highlight = sections[i].TestList[j].AcceptedValues[index].Highlight;
                
                sections[i].TestList[j].accepted = !highlight;
            }else{
                sections[i].TestList[j].accepted = true
            }
        }

        if(obj.type === 'text'){
            sections[i].TestList[j].value = e.target.value;
        }

        if(obj.type === 'numeric'){
            sections[i].TestList[j].numeric_value = e.target.value;
        }        

        this.setState({sections: sections});
    }

    async onSave(e, validate){
        if(!this.state.saved){
            //this.setState({saved:true});

            var results = [];
            this.state.sections.forEach((section)=>{
                section.TestList.forEach((test)=>{
                    var obj = {
                        //id:"",
                        value:test.value,
                        samples_id:this.state.samples_id,
                        analitical_test_id:test.ID
                    };

                    if(test.Result !== null){
                        obj.id = test.Result.id;
                    }

                    if(test.ShowNumericValue){
                        obj.numeric_value = test.numeric_value;
                    }

                    results.push(obj);
                });
            });

            var response = await sampleResultsSave(this.state.samples_id, results, this.props.waiting);
            if(response){
                if(validate){
                    this.select_section.openModal();
                }
            }            
        }        
    }

    onCancel(){
        this.props.history.goBack();
    }

    async onValidate(ids){
        var hf_id = sessionStorage.getItem('health_facilities_id');
        var response = await validator(this.state.samples_id, hf_id, ids, this.props.waiting);
        if(response){
            var msg = "<table class='table' style='text-align:left;'>"+
                        "<thead>"+
                        "<tr>"+
                            "<th style='text-align:center'>Sección</th>"+
                            "<th style='text-align:center'>Estatus</th>"+
                            "<th style='text-align:center'>Mensaje</th>"+
                        "</tr>"+
                        "</thead>"+
                        "<tbody>";
            for(var i =0;i < response.length;i++){
                msg += "<tr>"+
                            "<td>"+response[i].SectionName+"</td>"+
                            "<td>"+response[i].Status.toUpperCase()+"</td>"+
                            "<td>"+response[i].Message+"</td>"+
                        "</tr>";
            }
            
            msg += "</tbody></table>";
            
            swal({
                title: "Proceso Realizado",
                html:true,
                text: msg,
                confirmButtonColor:'var(--bg-active)',
                
            }, (isConfirm)=> {
                if (isConfirm) {                    
                    this.getSampleInfo(this.state.samples_id);
                    this.getLabSections();		
                }
            });            
        }
    }

    async onRemoveValidation(ids){
        var hf_id = sessionStorage.getItem('health_facilities_id');
        var response = await validatorDelete(this.state.samples_id, hf_id, ids, this.props.waiting);
        if(response){
            this.getSampleInfo(this.state.samples_id);
            this.getLabSections();           
        }
    }

    async openModalSections(){
        await this.select_section.setState({action:'remove_lab'});
        await this.select_section.openModal();
    }

    render(){
        const {t} = this.props;
        var id = this.props.match.params.id;

        return(
            <div className="col-xs-12">
                <BreadcrumbTitle 
                   menu={t('sidebar.nav.donors.MAIN')}
                   page={"Banco de Células -> Resultados de Laboratorio"}
                />
                
                <div className="col-xs-12 col-sm-10 col-sm-offset-1">
                    <h2 className="center form-grpup">Resultados de Laboratorio</h2>

                    <div className="col-xs-2 btn-validation">
                        <Button 
                            styles={{
                                border:0,
                                color:'#FFF',
                                width:'100%',
                                backgroundColor:(
                                    this.state.sample_info.validation_status === 'ACCEPTED' ?
                                        'green'
                                    : this.state.sample_info.validation_status === 'REJECT' ? 
                                        'red' 
                                    : 'orange'
                                )
                            }}
                            disabled
                            text={
                                this.state.sample_info.validation_status === 'ACCEPTED' ?
                                    'VALIDADO'
                                : this.state.sample_info.validation_status === 'REJECT' ? 
                                    'RECHAZADA' 
                                : 'PENDIENTE'
                            }
                        />                        
                    </div>

                    {this.state.sample_info.offerinf_cell_id !== null &&
                        <SampleInfoCells 
                            sampleInfo={this.state.sample_info} 
                            labelType={this.state.sample_info.offering_cell_id !== null ? 'Muestra:' : ''}
                        />
                    }

                    <LabSections 
                        {...this.props}
                        sections={this.state.sections}
                        changeResultValue={this.changeResultValue}
                        getLabSections={this.getLabSections}                
                        onRef={ref => this.lab_sections = ref}
                    />
                    <Laboratory 
                        {...this.props}
                        onValidate={this.onSave}
                        openModalSections={this.openModalSections}
                        validate={true}
                        sections={this.state.sections}
                        variables={{
                            id:id,
                            print_key:'sample_results',
                            confirm_key:'sample_results_confirm'
                        }}
                        onRef={ref => this.lab_toolbar = ref}
                    />
                    <div className="col-xs-12 center">
                        <ButtonForm 
                            label="GRABAR"
                            action={this.onSave}
                            //disabled={this.state.saved}
                        />
                        <ButtonForm 
                            label="CANCELAR"
                            action={this.onCancel}
                            primary={false}
                        />
                    </div>
                </div>

                <SelectSectionLab 
                    {...this.props}
                    sections={this.state.sections}
                    onValidate={this.onValidate}
                    onRemove={this.onRemoveValidation}
                    onRef={ref => this.select_section = ref}
                />
            </div>
        )
    }
}

export default translate('translations') (LaboratoryForm);